<section class="bg-white rounded-2xl border " *ngIf="isprofileaccess" >
    <div class="px-10 pt-10">
        <div class="flex items-start gap-6">
            <div class="relative w-[7.5rem] h-[7.5rem]">
    
    <div class="w-full h-full rounded-full overflow-hidden border border-zinc-200 bg-zinc-50">
        <img [src]="profileImageUrl" alt="" class="w-full h-full object-cover">
    </div>

    <!-- Hidden file input -->
    <input
        #profileImageInput
        type="file"
        accept="image/*"
        class="hidden"
        (change)="onProfileImageSelected($event)" />

    <!-- Edit Button -->
    <button
        type="button"
        (click)="profileImageInput.click()"
        class="absolute bottom-0 right-0 z-10 w-9 h-9 rounded-full bg-white border border-zinc-200 shadow-lg flex items-center justify-center ">
        <i class="ri-pencil-fill text-lg"></i>
    </button>

</div>

            <div class="pt-2">
                <h2 class="text-2xl font-semibold text-zinc-900">
                    {{ displayName }}
                </h2>
                <p class="mt-1 text-sm text-zinc-500">
                    {{ emailText }} <span *ngIf="roleLabel">- ({{ roleLabel }})</span>
                </p>
            </div>
        </div>
    </div>

    <div class="mt-8 border-t px-10  overflow-auto">
       <div *ngIf="isprofileaccess" role="tablist" class="flex gap-8 text-sm font-medium">
  @for (i of tabs; track $index) {
    <a
      [routerLink]="[i.url]"
      routerLinkActive  
      #rla="routerLinkActive"
      class="pt-4 pb-2 border-b-2 whitespace-nowrap"
      [ngClass]="{
        'text-sky-700 border-sky-700 font-semibold': rla.isActive,
        'text-zinc-500 border-transparent': !rla.isActive
      }">
      {{ i.name }}
    </a>
  }
</div>
    </div>

    <div class="px-10 pb-10 pt-6">
        <router-outlet></router-outlet>
    </div>
</section>
